<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22.008" viewBox="0 0 20 22.008">
    <g transform="translate(-1116 -734.997)">
      <rect class="a" width="18" height="11" rx="2" transform="translate(1117 745.005)"/>
      <path class="a" d="M7,11V7a5,5,0,0,1,9.9-1" transform="translate(1114 734.005)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "LockOpenIcon"
}
</script>

<style scoped>
.a {
  fill: none;
  stroke: #57b98f;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
</style>
